export interface IAlertSeverity {
  id: number;
  code: string;
  category: string;
}

export class AlertSeverity implements IAlertSeverity {
  public id: number;
  public code: string;
  public category: string;
}
